define('taoQtiItem/qtiXmlRenderer/renderers/interactions/OrderInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'orderInteraction',
        template : tpl
    };
});
